/**
 * /approvals — human-in-the-loop tool-call queue.
 *
 * No loader: identity is already in the dashboard-shell auth context, so we
 * read role + user id from there instead of paying an extra ``/v1/me`` RTT
 * on every navigation.
 */

import { ApprovalsBrowser } from "@/features/approvals/approvals-browser";
import { ApprovalsPageHeader } from "@/features/approvals/approvals-page-header";

import { useAuthState } from "../lib/auth";

export default function ApprovalsRoute() {
  const auth = useAuthState();
  return (
    <section className="space-y-4">
      <ApprovalsPageHeader />
      <ApprovalsBrowser viewerRole={auth.tenant.role} viewerUserId={auth.user.id} />
    </section>
  );
}
